import ApplicationController from "./application_controller";
import StimulusReflex from "stimulus_reflex";
import { FetchRequest } from '@rails/request.js'
import { get, post, put, patch, destroy } from '@rails/request.js'

import "~/stylesheets/board_containers.css";

/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */

  static targets = ["containers"];

  connect() {
    super.connect();
    StimulusReflex.register(this);
    this.element[this.identifier] = this;

    this.selection = [];
    this.altModifierKeyPressed = false;

    document.addEventListener(
      "keydown",
      function (event) {
        if (event.keyCode == 18) {
          this.altModifierKeyPressed = true;
        }
      }.bind(this),
    );
    document.addEventListener(
      "keyup",
      function (event) {
        if (event.keyCode == 18) {
          this.altModifierKeyPressed = false;
        }
      }.bind(this),
    );

    console.log("boardindex_controller.js connected");
  }

  async new(event) {
    event.preventDefault();

    let commandElement = event.target.closest("[data-current-container]");
    let parentContainerId = commandElement ? commandElement.dataset.currentContainer : null;
    this.getModalController().loadHTMLModal(`/board_containers/new`, { parent_id: parentContainerId });
  }
  edit(event) {
    event.preventDefault();
    let button = this.getParent(event.target, "btn");

    this.clearModalContent();
    this.getModalController().show(event);
    this.getModalController().hideFooter();

    this.getModalController().loadHTMLModal(`/board_containers/${button.dataset.id}/edit`, {})
  }
  save(event) {
    event.preventDefault();
    let button = this.getParent(event.target, "btn");
    let title = document.querySelector("#board_container_title").value;
    this.getModalController().close();
    this.stimulate("BoardIndexReflex#saveContainer", button, title);
  }
  deleteItem(event) {
    event.preventDefault();
    let item = event.target.closest("[data-type]");
    let message = event.target.dataset.confirmMessage || "Are you sure you would like to delete this item?";

    const ok = confirm(message);
    if (ok) {

      this.stimulate("BoardIndexReflex#deleteItems", event.target, {
        deleteItems: [[item.dataset.type, item.dataset.id]],
      });
    }
  }
  async deleteItems(event) {
    let confirmTarget = event.target.closest("[data-confirm]");
    let countItems = this.selection.length;
    if (countItems == undefined || countItems == 0) {
      alert("No items selected!");
      return false;
    }
    let message = confirmTarget.dataset.confirmmsg || "Are you sure you would like to delete " + countItems + " items?";
    const ok = confirm(message);
    if (!ok) return false;

    const response = await destroy("/board_containers/destroy_items", { body: { deleteItems: this.getSelectedItems() } });
    if (response.ok) {
      const data = await response.json;
      data.destroyed_items.forEach(item => {
        const el = this.getItem(item[0], item[1]);
        el.style.transition = "opacity 0.5s ease";
        el.style.opacity = "0";
        setTimeout(() => el.remove(), 500);
      });
      this.flash(data.message, "success");
    }
    return true;
  }
  drag(event) {
    event.preventDefault();
    this.dragItem = this.getParent(event.target, "list-group-item");

    this.dragItem.classList.add("opacity-50");
    for (var i = 0; i < this.selection.length; i++) {
      this.selection[i].classList.add("opacity-50");
    }
  }
  dragEnd(event) {
    event.preventDefault();
    this.dragItem.classList.remove("opacity-50");
    for (var i = 0; i < this.selection.length; i++) {
      this.selection[i].classList.remove("opacity-50");
    }
    this.disableAllDragovers();
  }
  disableAllDragovers() {
    let dragoverItems = document.querySelectorAll(".boardindex-dragover");
    for (var i = 0; i < dragoverItems.length; i++) {
      this.removeClasses(dragoverItems[i], [
        "boardindex-dragover",
        "bg-warning",
      ]);
    }
  }
  dragOverContainer(event) {
    console.log("dragOverContainer " + event.target.closest('li'));
    event.preventDefault();
    this.disableAllDragovers();
    this.dragOverTarget = event.target.closest('li.boardcontainer-list-item');
    if (!this.dragOverTarget) {
      this.dragOverTarget = event.target.closest('#move-up-field');
    }
    if (!this.dragOverTarget) {
      return false;
    }
    if(this.dragOverTarget.dataset.type == this.dragItem.dataset.type &&
      this.dragOverTarget.dataset.id == this.dragItem.dataset.id) {
      return false;
    }
    if (this.dragOverTarget.dataset.type == "BoardContainer") {
      this.addClasses(this.dragOverTarget, [
        "boardindex-dragover",
        "bg-warning",
      ]);
    }
  }
  dragLeaveContainer(event) {
    event.stopPropagation();
    event.preventDefault();

    if (this.dragOverTarget) {
      this.removeClasses(this.dragOverTarget, [
        "boardindex-dragover",
        "bg-warning",
      ]);
    }
    if (this.getParent(event.target, "boardcontainer-card")) {
      this.removeClasses(this.getParent(event.target, "boardcontainer-card"), [
        "boardindex-dragover",
        "bg-warning",
      ]);
      event.target.closest('li').classList.remove("bg-warning");
    }
  }

  async dropOnContainer(event) {
    event.stopPropagation();
    event.preventDefault();

    var dropTarget = event.target.closest('li.boardcontainer-list-item');
    if (!dropTarget) {
      dropTarget = event.target.closest('#move-up-field');
      if (!dropTarget) {
        return false;
      }
    }

    let moveItems = this.getSelectedItems();
    moveItems.push([this.dragItem.dataset.type, this.dragItem.dataset.id]);

    // console.log("dropped: " + this.dragItem.dataset.type + ":" + this.dragItem.dataset.id + " on: BoardContainer:" + dropTarget.dataset.id)
    const request = new FetchRequest('patch',
      "/board_containers/move/" + dropTarget.dataset.id,
      {
        body: JSON.stringify({
          authenticity_token: this.getCsrfToken(),
          moveItems: moveItems
        })
      }
    );
    const response = await request.perform()
    console.log("response: " + JSON.stringify(response))
    if (response.ok) {
      console.log("response ok")
      const json = await response.json
      console.log("json returned: " + JSON.stringify(json))
      this.flash(json.message, "success")

      this.getSelectedElements(moveItems).forEach((item) => {
        item.remove();
      });
      this.disableAllDragovers();
    } else {
      console.log("response NOT ok")
    }
  }
  getItem(klazz, id) {
    return this.element.querySelector('li[data-type="' + klazz + '"][data-id="' + id + '"]')
  }
  getSelectedItems() {
    let selectedItems = [];
    for (var i = 0; i < this.selection.length; i++) {
      selectedItems.push([
        this.selection[i].dataset.type,
        this.selection[i].dataset.id,
      ]);
    }
    return selectedItems;
  }
  getSelectedElements(items = this.getSelectedItems()) {
    let selectedElements = [];
    for (var i = 0; i < items.length; i++) {
      selectedElements.push(this.element.querySelector('li[data-type="' + items[i][0] + '"][data-id="' + items[i][1] + '"]'));
    }
    return selectedElements;
  }
  select(event) {
    let link = event.target.closest(".command-link");
    if (link) {
      window.location.href = link.href;
      return;
    }
    let container = event.target.closest("li.list-group-item");
    let selectedArrayItem = [container.dataset.type, container.dataset.id];
    let checkbox = container.querySelector("input[type='checkbox']");
    let checkboxLabel = container.querySelector("label.list-item-label");

    // console.log("selected: " + container + "checkbox state: " + (checkbox.checked ? "true" : "false"));
    // console.log("selected: " + container + "checkbox state: " + (checkbox.checked ? "true" : "false"));

    if (checkbox.checked) {
      checkbox.checked = false;
      this.selection = this.selection.filter((item) => item !== container);
      checkboxLabel.classList.remove("boardcontainer-highlight");
    } else {
      checkbox.checked = true;
      this.selection.push(container);
      checkboxLabel.classList.add("boardcontainer-highlight");
    }
    // console.log("selection: " + this.selection)
  }
  keydown(event) {
    var code = event.keyCode;
    let listenKeys = { 18: "alt" };

    this.altModifierKeyPressed = true;
  }

  keyup(event) {
    var code = event.keyCode;
    let listenKeys = { 18: "alt" };
    // console.log("key up" + code);
    this.altModifierKeyPressed = false;
  }
}
